import { Filters } from "@nerdjs/nerd-core";
import { NerdAdvancedSearch } from "@nerdjs/nerd-ui";
import { AdvancedSearchDefinition } from "@nerdjs/nerd-ui/dist/nerdAdvancedSearch/types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  setTimerFilters,
  setTimerSearchOpen,
} from "../../redux/timer/timerActions";
import {
  timerFiltersSelector,
  timerSearchOpenSelector,
} from "../../redux/timer/timerSelector";
import { useGetKronosTimersSearchMetadataQuery } from "../../../redux/kronos/kronosEndpoints";
import { ProjectAutocomplete } from "../project/projectAutocomplete";
import { TaskAutocomplete } from "../task/taskAutocomplete";
import { useQuery } from "../useQuery";
import { UserAutocomplete } from "../user/userAutocomplete";
/**
 *
 * @returns {ReactElement} TimerSearch page
 */
export function TimerSearch() {
  const dispatch = useDispatch();
  const searchOpen = useSelector(timerSearchOpenSelector);
  const query = useQuery();
  const filtersString = query.get("filters");
  const filters: Filters = filtersString ? JSON.parse(filtersString) : [];
  const filtersInRedux = useSelector(timerFiltersSelector);
  const { data: searchMetadata = [] } = useGetKronosTimersSearchMetadataQuery();
  const navigate = useNavigate();

  useEffect(() => {
    //We restore the filters from redux if they exists
    if (filtersInRedux && (!Array.isArray(filters) || filters.length === 0)) {
      query.set("filters", JSON.stringify(filtersInRedux));
      navigate({ search: query.toString() });
    }
  }, []);

  useEffect(() => {
    // we save the filters in redux whenever they change
    if (filtersString) {
      const filters = JSON.parse(filtersString);
      dispatch(setTimerFilters(filters));
    }
  }, [filtersString]);

  const definition: AdvancedSearchDefinition[] = [
    {
      id: "userID",
      name: "timers.userID",
      label: "User",
      type: "string",
      faIcon: "fa-solid fa-user",
      renderInput: (value, onChange) => (
        <UserAutocomplete
          userID={value as number}
          onChange={(e) => onChange(e?.id)}
          autoFocus
          variant="inputBase"
          size="small"
        />
      ),
    },
    {
      id: "projectID",
      name: "timers.projectID",
      label: "Project",
      type: "string",
      faIcon: "fa-regular fa-folder-open",
      renderInput: (value, onChange) => (
        <ProjectAutocomplete
          projectID={value as number}
          onChange={(e) => onChange(e?.id)}
          autoFocus
          variant="inputBase"
          size="small"
        />
      ),
    },
    {
      id: "taskID",
      name: "timers.taskID",
      label: "Task",
      type: "string",
      faIcon: "fa-regular fa-hammer",
      renderInput: (value, onChange) => (
        <TaskAutocomplete
          taskID={value as number}
          onChange={(e) => onChange(e?.id)}
          autoFocus
          variant="inputBase"
          size="small"
        />
      ),
    },
    {
      id: "startDateUTC",
      name: "timers.startDateUTC",
      label: "Start Date",
      type: "date",
      faIcon: "fa-solid fa-calendar-days",
    },
    {
      id: "endDateUTC",
      name: "timers.endDateUTC",
      label: "End Date",
      type: "date",
      faIcon: "fa-solid fa-calendar-days",
    },
  ];

  return (
    <NerdAdvancedSearch
      definitions={definition}
      searchMetadata={searchMetadata}
      open={searchOpen}
      setOpen={(o) => dispatch(setTimerSearchOpen(o))}
      onSearch={(q) => dispatch(setTimerFilters(q as Filters))}
    />
  );
}
